import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=c929aaca&scoped=true&"
import script from "./Professional.vue?vue&type=script&lang=js&"
export * from "./Professional.vue?vue&type=script&lang=js&"
import style0 from "./Professional.vue?vue&type=style&index=0&id=c929aaca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c929aaca",
  null
  
)

export default component.exports